// Flow types automatically removed

import { DesignerDirectoryRenderer } from './DesignerDirectoryRenderer';
import { QueryParamsProvider } from '../shared/QueryParamsProvider';
import { QueryParamsConsumer } from '../shared/QueryParamsConsumer';
import {
    mapQueryParamsToProps,
    mapUpdateToQueryParams,
} from './helpers/designerDirectoryQueryParams';
export const DesignerDirectoryContainer = ({ environment, search }) => (
    <QueryParamsProvider search={search}>
        <QueryParamsConsumer
            mapQueryParamsToProps={mapQueryParamsToProps}
            mapUpdateToQueryParams={mapUpdateToQueryParams}
        >
            {(queryParams, onQueryParamsChange) => (
                <DesignerDirectoryRenderer
                    environment={environment}
                    queryParams={queryParams}
                    onQueryParamsChange={onQueryParamsChange}
                />
            )}
        </QueryParamsConsumer>
    </QueryParamsProvider>
);
